module.exports = __webpack_public_path__ + "img/dark.e778675d.png";